<form id="subpoena-opposingcounseal-form-pg" [formGroup]="formGroup">
    <!-- Code Implementation for Contact Information class="flex flex-col gap-4" -->

    <p-panel styleClass="border-0 panel-dotted-heading">

        <div formArrayName="opposingCounseals">
            <div *ngFor="let opposingCounseal of opposingCounseals.controls; let i = index" [formGroupName]="i"
                [ngClass]="{'mt-5': i > 0}">
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                            <h2 class="contactListNo">
                                <span *ngIf="i<9">Opposing Counsel {{ '0'+ (i + 1) }}</span>
                                <span *ngIf="i>=9">Opposing Counsel {{ i + 1 }}</span>
                            </h2>
                            <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true"
                                aria-label="Delete" label="Delete"
                                *ngIf="opposingCounseals && opposingCounseals.length > 1"
                                (onClick)="removeOpposingCounseal(i)"></p-button>
                        </div>
                        <!--  <hr /> -->
                    </div>
                </div>
                <div class="row mb-0 mb-lg-3">
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-record-subject-name-{{i}}"
                            class="form-label d-block required-asterisk">Record Subject Name</label>
                        <!-- <p-dropdown [options]="subjectNames" formControlName="recordSubjectName" styleClass="w-100"
                            id="subpoena-opposingcounseal-record-subject-name-{{i}}"
                            placeholder="Select record subject name"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('recordSubjectName', opposingCounseal)}" /> -->
                        <p-multiselect [options]="subjectNames" [showToggleAll]="false" [filter]="false" display="chip" id="subpoena-opposingcounseal-record-subject-name-{{i}}" styleClass="w-100" 
                        formControlName="recordSubjectName" optionLabel="name" placeholder="Select record subject name" 
                            [ngClass]="{'ng-invalid ng-dirty' : isError('recordSubjectName', opposingCounseal)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('recordSubjectName', opposingCounseal)"
                            class="error-label">This field is mandatory</small>
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-opposing-counsel-attorney-name-{{i}}"
                            class="form-label d-block required-asterisk">Opposing Counsel Attorney Name</label>
                        <input pInputText type="text"
                            id="subpoena-opposingcounseal-opposing-counsel-attorney-name-{{i}}" class="w-100"
                            placeholder="Enter opposing counsel attorney name"
                            formControlName="opposingCounselAttorneyName"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('opposingCounselAttorneyName', opposingCounseal)}" />
                        <small id="order-info-ref-num-error"
                            *ngIf="isError('opposingCounselAttorneyName', opposingCounseal)" class="error-label">This
                            field is mandatory</small>
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-opposing-counsel-firm-name-{{i}}"
                            class="form-label d-block required-asterisk">Opposing Counsel Firm Name</label>
                        <input pInputText type="text" id="subpoena-opposingcounseal-opposing-counsel-firm-name-{{i}}"
                            class="w-100" placeholder="Enter opposing counsel firm name"
                            formControlName="opposingCounselFirmName"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('opposingCounselFirmName', opposingCounseal)}" />
                        <small id="order-info-ref-num-error"
                            *ngIf="isError('opposingCounselFirmName', opposingCounseal)" class="error-label">This field
                            is mandatory</small>
                    </div>
                </div>
                <div class="row mb-0 mb-lg-3">
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-street-address-{{i}}" class="form-label d-block">Street
                            Address</label>
                        <input pInputText type="text" id="street-address-{{i}}" class="w-100"
                            placeholder="Enter street address" formControlName="streetAddress" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-city-{{i}}" class="form-label d-block">City</label>
                        <input pInputText type="text" id="subpoena-opposingcounseal-city-{{i}}" class="w-100"
                            placeholder="Enter city" formControlName="city" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-state-{{i}}" class="form-label d-block">State</label>
                        <p-select formControlName="state" id="subpoena-opposingcounseal-state-{{i}}" [options]="states"
                            optionLabel="name" placeholder="Select state" styleClass="w-100" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-zip-{{i}}" class="form-label d-block">Zip</label>
                        <input pInputText type="text" id="subpoena-opposingcounseal-zip-{{i}}" class="w-100"
                            placeholder="Enter zip" formControlName="zip" />
                    </div>
                </div>
                <div class="row mb-0 mb-lg-3">
                    <div class="col-8 col-md-2 col-lg-2 mb-3 mb-sm-0 pe-1">
                        <label for="subpoena-opposingcounseal-phone-{{i}}" class="form-label d-block">Phone</label>
                        <input pInputText type="text" id="subpoena-opposingcounseal-phone-{{i}}" class="w-100"
                            placeholder="Enter phone" formControlName="phone" />
                    </div>
                    <div class="col-4 col-md-1 col-lg-1 mb-3 mb-sm-0 ps-1">
                        <label for="subpoena-opposingcounseal-phone-extn-{{i}}"
                            class="form-label d-block">Extension</label>
                        <input pInputText type="number" id="subpoena-opposingcounseal-phone-extn-{{i}}"
                            placeholder="Enter" formControlName="extn" class="w-100" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-fax-{{i}}" class="form-label d-block">Fax</label>
                        <input pInputText type="text" id="subpoena-opposingcounseal-fax-{{i}}" class="w-100"
                            placeholder="Enter fax" formControlName="fax" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-opposingcounseal-email-{{i}}" class="form-label d-block">Email</label>
                        <input pInputText type="email" id="subpoena-opposingcounseal-email-{{i}}" class="w-100"
                            placeholder="Enter email" formControlName="email" />
                    </div>
                </div>
            </div>
        </div>
        <p-button label="Add Opposing Counsel" styleClass="px-0" icon="pi pi-plus" (onClick)="addOpposingCounseal()"
            [link]="true" />
    </p-panel>



    <p-panel styleClass="border-0 panel-dotted-heading">
        <div formArrayName="defendants" class="mt-5">
            <div *ngFor="let defendant of defendants.controls; let i = index" [formGroupName]="i"
                [ngClass]="{'mt-5': i > 0}">
                <div class="row mb-3">
                    <div class="col-sm-12">
                        <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                            <h2 class="contactListNo">
                                <span *ngIf="i<9">Defendant {{ '0'+ (i + 1) }}</span>
                                <span *ngIf="i>=9">Defendant {{ i + 1 }}</span>
                            </h2>
                            <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true"
                                aria-label="Delete" label="Delete" *ngIf="defendants && defendants.length > 1"
                                (onClick)="removeDefendant(i)"></p-button>
                        </div>
                        <!--  <hr /> -->
                    </div>
                </div>
                <div class="row mb-0 mb-lg-3">
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-defendant-name-{{i}}"
                            class="form-label d-block required-asterisk">Defendant
                            Name</label>
                        <input pInputText type="text" id="subpoena-defendant-name-{{i}}" class="w-100"
                            placeholder="Enter defendant name" formControlName="name"
                            [ngClass]="{'ng-invalid ng-dirty' : isError('name', defendant)}" />
                        <small id="order-info-ref-num-error" *ngIf="isError('name', defendant)" class="error-label">This
                            field is mandatory</small>
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-defendant-street-address-{{i}}" class="form-label d-block">Street
                            Address</label>
                        <input pInputText type="text" id="street-address-{{i}}" class="w-100"
                            placeholder="Enter street address" formControlName="streetAddress" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-defendant-city-{{i}}" class="form-label d-block">City</label>
                        <input pInputText type="text" id="subpoena-defendant-city-{{i}}" class="w-100"
                            placeholder="Enter city" formControlName="city" />
                    </div>
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-defendant-state-{{i}}" class="form-label d-block">State</label>
                        <p-select formControlName="state" id="subpoena-defendant-state-{{i}}" [options]="states"
                            optionLabel="name" placeholder="Select state" styleClass="w-100" />
                    </div>

                </div>
                <div class="row mb-0 mb-lg-3">
                    <div class="col-sm-3 mb-3 mb-sm-0">
                        <label for="subpoena-defendant-zip-{{i}}" class="form-label d-block">Zip</label>
                        <input pInputText type="text" id="subpoena-defendant-zip-{{i}}" class="w-100"
                            placeholder="Enter zip" formControlName="zip" />
                    </div>
                </div>
            </div>
        </div>
        <p-button label="Add Defendant" styleClass="px-0" icon="pi pi-plus" (onClick)="addDefendant()" [link]="true" />
    </p-panel>


    <p-panel styleClass="border-0 panel-dotted-heading mt-5">
        <!-- <div class=""> -->
        <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-case-number" class="form-label d-block required-asterisk">Case Number </label>
                <input pInputText type="text" id="subpoena-case-number" class="w-100" placeholder="Enter case number"
                formControlName="caseNumber" [ngClass]="{'ng-invalid ng-dirty' : isError('caseNumber')}" />
                <small id="subpoena-case-number-error" *ngIf="isError('caseNumber')" class="error-label">This field is
                    mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-judge" class="form-label d-block">Judge</label>
                <input pInputText type="text" id="subpoena-judge" class="w-100" placeholder="Enter judge"
                    formControlName="judge" />
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-court" class="form-label d-block required-asterisk">Court</label>
                <input pInputText type="text" id="subpoena-court" class="w-100" placeholder="Enter court"
                    formControlName="court" [ngClass]="{'ng-invalid ng-dirty' : isError('court')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('court')" class="error-label">This field is
                    mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-court-street-address" class="form-label d-block">Court Street Address</label>
                <input pInputText type="text" id="subpoena-court-street-address" class="w-100"
                    placeholder="Enter court street address" formControlName="courtStreetAddress" />
            </div>
        </div>
        <div class="row mb-0 mb-lg-3">
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-court-city" class="form-label d-block">City</label>
                <input pInputText type="text" id="subpoena-court-city" class="w-100" placeholder="Enter city"
                    formControlName="cityName" />
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-jurisdiction-county" class="form-label d-block required-asterisk">Jurisdiction
                    County</label>
                <input pInputText type="text" id="subpoena-jurisdiction-county" class="w-100"
                    placeholder="Enter jurisdiction county" formControlName="jurisdictionCounty"
                    [ngClass]="{'ng-invalid ng-dirty' : isError('jurisdictionCounty')}" />
                <small id="order-info-ref-num-error" *ngIf="isError('jurisdictionCounty')" class="error-label">This
                    field is mandatory</small>
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-defendant-state" class="form-label d-block">State</label>
                <p-select formControlName="state" id="subpoena-defendant-state" [options]="states" optionLabel="name"
                    placeholder="Select state" styleClass="w-100" />
            </div>
            <div class="col-sm-3 mb-3 mb-sm-0">
                <label for="subpoena-court-zopcode" class="form-label d-block">Zip</label>
                <input pInputText type="text" id="subpoena-court-zopcode" class="w-100" placeholder="Enter zip"
                    formControlName="zipCode" />
            </div>
        </div>
        <!-- </div> -->
    </p-panel>
</form>
<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'" [acceptLabel]="'Yes'"
    (acceptModalClick)="delete()" (rejectModalClick)="showDeleteModal = false">
    <span>Are you sure want to delete this?</span>
</app-modal>